
























import Enumerable from "linq";
import { Component, Mixins, Watch, Prop, Emit } from "vue-property-decorator";
import { MultiSelectableMixin } from "./mixins";
import InfiniteLoading from "vue-infinite-loading";

@Component({
  components: {
    InfiniteLoading
  },
})
export default class MultiCustomListBoxSelector extends Mixins(MultiSelectableMixin) {
  @Prop({ default: false })
  isClearable: boolean;

  @Prop({ default: 50 })
  loadChunkSize: number;

  @Emit()
  loadedOptionsUpdated(loadedOptions: any[]): void {}

  @Emit()
  filteredOptionsUpdated(filteredOptions: any[]): void {}

  loadedOptions: any[] = [];
  private chunkedCount: number = 0;
  private infiniteRetryTimer: NodeJS.Timeout = null;

  $refs!: {
    infiniteLoading: InfiniteLoading,
  };

  private pressed: boolean = false;
  private startIndex: number = -1;
  private activeIndex: number = -1;

  mounted() {
    this.filteredOptionsUpdated(this.filteredOptions);
  }

  onInfinite(): void {
    clearTimeout(this.infiniteRetryTimer);
    this.chunkList();
  }

  private chunkList(): void {
    for (let i = this.chunkedCount; i < (this.chunkedCount + this.loadChunkSize); i++) {
      if (i >= this.filteredOptions.length) {
        this.chunkedCount = this.filteredOptions.length;
        this.$refs.infiniteLoading.stateChanger.complete();
        return;
      }
      this.loadedOptions.push(this.filteredOptions[i]);
    }
    this.chunkedCount += this.loadChunkSize;
    this.$refs.infiniteLoading.stateChanger.loaded();
  }

  private resetChunkList(): void {
    this.loadedOptions = [];
    this.chunkedCount = 0;
    if (this.$refs.infiniteLoading) {
      this.$refs.infiniteLoading.stateChanger.reset();
      this.infiniteRetryTimer = setTimeout(this.resetChunkList, 500);
    }
  }

  optionClass(option: any, index: number): string {
    return [
      Enumerable.from(this.selectedOptions).contains(option)
        ? "selected"
        : undefined,
      this.pressed && Math.min(this.startIndex, this.activeIndex) <= index && index <= Math.max(this.startIndex, this.activeIndex)
        ? "selecting"
        : undefined,
    ].filter((v) => v).join(" ");
  }

  onMouseDown(event: PointerEvent, option: any, index: number): void {
    this.resetMouseStatus();
    this.pressed = true;
    this.startIndex = index;
    this.activeIndex = index;
  }

  onMouseMove(event: PointerEvent, option: any, index: number): void {
    if (event.buttons === 0) {
      this.resetMouseStatus();
      return;
    }
    this.activeIndex = index;
  }

  onMouseUp(event: PointerEvent, option: any, index: number): void {
    if (this.pressed) {
      const selected = Enumerable.from(this.selectedOptions).contains(option);
      const single = this.startIndex === index;
      const options = (single && event.ctrlKey)
        // 部分選択
        ? selected
          ? Enumerable.from(this.selectedOptions)
              .where(e => e !== option)
              .toArray()
          : this.selectedOptions.concat(option) // 並び順考慮するならfilteredOptionsから絞りなおすべき？
        // 範囲選択
        : selected && single
          ? []
          : Enumerable.from(this.filteredOptions)
              .skip(Math.min(this.startIndex, index))
              .take(Math.abs(this.startIndex - index) + 1)
              .toArray();
      this.selectedOptions = (this.isClearable || options.length > 0)
        ? options
        : [option];
    }
    this.resetMouseStatus();
  }

  private resetMouseStatus() {
    this.pressed = false;
    this.startIndex = -1;
    this.activeIndex = -1;
  }

  @Watch("filteredOptions")
  onFilteredOptionsUpdated(newValue: any[], oldValue: any[]): void {
    this.resetChunkList();

    // 選択状態を更新
    this.selectedOptions = Enumerable.from(this.selectedOptions)
      .where(o => this.optionFilter(o))
      .toArray();

    this.filteredOptionsUpdated(newValue);
  }

  @Watch("loadedOptions")
  onLoadedOptionsUpdated() {
    this.loadedOptionsUpdated(this.loadedOptions);
  }
}
